import Skeleton from "react-loading-skeleton";


export default function TableLoader() {
    return (

        <table className="divide-y-1 text-base divide-gray-600 w-full">
            <thead>
                <tr>
                    <th className="table-th"><Skeleton className="h-2" /></th>
                    <th className="table-th"><Skeleton className="h-2" /></th>
                    <th className="table-th"><Skeleton className="h-2" /></th>
                </tr>
            </thead>

            <tbody className="divide-y divide-slate-600/50">
                <tr>
                    <td className="table-td"><Skeleton className="" /></td>
                    <td className="table-td"><Skeleton className="" /></td>
                    <td className="table-td">
                        <Skeleton className="w-full" />
                    </td>
                </tr>
                <tr>
                    <td className="table-td"><Skeleton className="" /></td>
                    <td className="table-td"><Skeleton className="" /></td>
                    <td className="table-td">
                        <Skeleton className="w-full" />
                    </td>
                </tr>
                <tr>
                    <td className="table-td"><Skeleton className="" /></td>
                    <td className="table-td"><Skeleton className="" /></td>
                    <td className="table-td">
                        <Skeleton className="w-full" />
                    </td>
                </tr>
                <tr>
                    <td className="table-td"><Skeleton className="" /></td>
                    <td className="table-td"><Skeleton className="" /></td>
                    <td className="table-td">
                        <Skeleton className="w-full" />
                    </td>
                </tr>
            </tbody>
        </table>


    )
};